import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { ErrorService } from '../../services/error.service';
import type { WaHideEvent } from '@web.awesome.me/webawesome-pro';

@Component({
    selector: 'app-error-modal',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    template: `
        <wa-dialog class="error-modal" [open]="errorService.hasError()" (wa-hide)="onHide($event)">
            @if (errorService.error(); as err) {
                <section slot="label">
                    <wa-icon class="error-icon" name="exclamation-triangle" />
                    @if (err.title) {
                        <h5>{{ err.title }}</h5>
                    }
                </section>

                <p class="error-message">{{ err.message }}</p>

                <div class="dialog-footer" slot="footer">
                    <wa-button variant="brand" (click)="onDismiss()">Dismiss</wa-button>
                </div>
            }
        </wa-dialog>
    `,
    styles: `
        .error-modal {
            --width: 400px;
        }

        .error-modal [slot='label'] {
            display: flex;
            align-items: center;
            gap: 12px;
        }

        .error-icon {
            color: var(--active-orange);
            font-size: 1.5rem;
        }

        .error-message {
            color: var(--neutral-10);
            line-height: 1.5;
        }

        .dialog-footer {
            display: flex;
            justify-content: flex-end;
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorModal {
    readonly errorService = inject(ErrorService);

    onHide(e: WaHideEvent) {
        const target = e.target as HTMLElement;
        if (!target.localName.includes('wa-dialog')) {
            return;
        }
        this.errorService.dismiss();
    }

    onDismiss() {
        this.errorService.dismiss();
    }
}
